module.exports = __webpack_public_path__ + "static/CameraMate-89022892571a71794487fde02ac0927b.jpg";